module.exports = __webpack_public_path__ + "static/Organise-9641b4bbbded688fbdbce323dd79bbbe.svg";